import { render } from "./SongItem.vue?vue&type=template&id=0074ad34&scoped=true"
import script from "./SongItem.vue?vue&type=script&lang=js"
export * from "./SongItem.vue?vue&type=script&lang=js"

import "./SongItem.vue?vue&type=style&index=0&id=0074ad34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0074ad34"]])

export default __exports__